import React from "react";

const Filters = ({ activeFilters, handleFilters }) => {
  return (
    <div className="filters">
      {activeFilters.length > 0 && <h3>Selected filters</h3>}
      <div className="active_filters">
        {activeFilters.map((filter, index) => (
          <div
            className="filter_choosen"
            key={index}
            onClick={() => handleFilters(filter)}
          >
            {filter.CertificateName ||
              filter.StatementName ||
              filter.OtherName ||
              filter.Name}
            <span
              style={{ marginLeft: "10px", fontWeight: "bold" }}
              title={
                filter.CertificateName ||
                filter.StatementName ||
                filter.OtherName ||
                filter.Name
              }
            >
              X
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Filters;
